import Tips from './Tips/Tips';

export default Tips;